let baseUrl = "http://localhost:8000";
let mediaUrl = "http://localhost:8000";
let accountUrl = "http://localhost:9000";
let accountDomain = "http://localhost:3001";
let bookingDomain = "http://localhost:3000";
let recaptchaLink = "6Lca50wrAAAAAN9xJSjfd5fkI0j3V1xujdI1yJ9e";

if (typeof window !== "undefined") {
  const host = window.location.host;

  if (host === "qa-web.devprestigeride.com") {
    baseUrl = "https://www.apitest.devprestigeride.com";
    mediaUrl = "https://www.apitest.devprestigeride.com";
    accountUrl = "https://www.testaccount.devprestigeride.com";
    accountDomain = "https://account.devprestigeride.com";
    bookingDomain = "https://booking.devprestigeride.com";
    recaptchaLink = "6Lca50wrAAAAAN9xJSjfd5fkI0j3V1xujdI1yJ9e";
  } else if (host === "www.prestigeride.com") {
    baseUrl = "https://www.api.devprestigeride.com";
    mediaUrl = "https://www.api.devprestigeride.com";
    accountUrl = "https://www.account-api.devprestigeride.com";
    accountDomain = "https://account.prestigeride.com";
    bookingDomain = "https://booking.prestigeride.com";
    recaptchaLink = "6LcQCBsqAAAAAOpS9QHwUyS5v47VfLCW0QLP1DjY";
  }
}

const config = {
  baseUrl: baseUrl,
  mediaUrl: mediaUrl,
  accountUrl,
  accountDomain,
  bookingDomain,
  recaptchaLink,
};
export default config;
